function tabCarousel() {
	$('.tab-carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		arrows: true,
		dots: false,
		infinite: false,
		responsive: [

			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					accesibility: false,
					draggable: false,
					swipe: false,
					touchMove: false,
					arrows: false,
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
}
tabCarousel();

function showTabCarousel() {
	jQuery('.nav-tabs').on('shown.bs.tab', function (e) {
		
		var target = $(e.target).attr("href");
		if ($(target).find('.slick-slider').length) {
			$(target + ' .slick-slider').slick('setPosition');
		}
	});

	
}

showTabCarousel();


function imageContentCarousel() {
    $('.imageContent-carousel').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [
  
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
}

imageContentCarousel();
